import { render } from "./ApplicationUnderReviewCard.vue?vue&type=template&id=7f3df1b5"
import script from "./ApplicationUnderReviewCard.vue?vue&type=script&lang=js"
export * from "./ApplicationUnderReviewCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__